import React, { FC, useMemo } from "react";

import { ResaleStatusReasons, ResaleStatuses } from "@api/graphql";
import { getDisplayValueFromDBValue } from "@util/index";
import { mapResaleStatusReasonsToDisplayFriendlyText, mapStatusToDisplayFriendlyText } from "@util/resale";

import { StatusBadge } from "./StatusBadge";

import styles from "./ResaleStatusBadge.module.scss";

interface ResaleStatusBadgeProps {
  cellValue: ResaleStatuses | undefined;
  resaleStatusReason?: ResaleStatusReasons;
  displayReason?: boolean;
  isExternalUser?: boolean;
}

export const ResaleStatusBadge: FC<ResaleStatusBadgeProps> = ({
  cellValue,
  resaleStatusReason,
  displayReason = false,
  isExternalUser = false,
}) => {
  const currentResaleStatus = useMemo(() => {
    if (!cellValue) {
      return undefined;
    }

    const mappedStatus = mapStatusToDisplayFriendlyText({ status: cellValue, isExternalUser });
    if (mappedStatus) {
      if (isExternalUser) {
        return mappedStatus;
      }
      const reason = resaleStatusReason && mapResaleStatusReasonsToDisplayFriendlyText(resaleStatusReason);
      const label =
        displayReason && (cellValue === ResaleStatuses.RESEARCH_REQUIRED || cellValue === ResaleStatuses.OPTED_OUT)
          ? `${getDisplayValueFromDBValue(cellValue)}: ${reason}`
          : getDisplayValueFromDBValue(cellValue);
      return {
        label,
        className: mappedStatus.className,
      };
    }
  }, [cellValue, displayReason, isExternalUser, resaleStatusReason]);

  if (!cellValue) {
    return <StatusBadge cellClassName="undefined-badge" cellValue="undefined" customStyle={styles} />;
  }

  return (
    <StatusBadge
      cellClassName={currentResaleStatus?.className}
      cellValue={currentResaleStatus?.label}
      customStyle={styles}
    />
  );
};
